(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var stickyBar = document.getElementById('sticky-atc');
    if (!stickyBar) return;

    var form = document.querySelector('product-form form[action*="/cart/add"]');
    if (!form) return;

    var originalButton = form.querySelector('button[type="submit"], button[name="add"]');
    var stickyButton = document.getElementById('sticky-atc-button');

    var soldOutText = originalButton && originalButton.disabled
      ? originalButton.textContent.trim()
      : null;
    var defaultText = stickyButton.textContent.trim();

    // Klik op de sticky knop activeert de originele knop, zodat Dawn's eigen
    // add-to-cart / cart-drawer logica (en eventuele apps) blijft werken.
    stickyButton.addEventListener('click', function () {
      if (originalButton) originalButton.click();
    });

    // Toon/verberg de sticky balk op basis van de zichtbaarheid van de originele knop.
    if (originalButton && 'IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            stickyBar.hidden = false;
            stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      visibilityObserver.observe(originalButton);
    }

    function syncButtonState() {
      if (!originalButton) return;
      stickyButton.disabled = originalButton.disabled;
      stickyButton.textContent = originalButton.disabled
        ? originalButton.textContent.trim() || soldOutText || defaultText
        : defaultText;
    }
    syncButtonState();

    // Volg wijzigingen in de disabled-status (bv. niet-beschikbare variant).
    if (originalButton) {
      var stateObserver = new MutationObserver(syncButtonState);
      stateObserver.observe(originalButton, { attributes: true, attributeFilter: ['disabled'] });
      var textObserver = new MutationObserver(syncButtonState);
      textObserver.observe(originalButton, { childList: true, subtree: true, characterData: true });
    }
  });
})();